import {LightLayoutNodeFCProps, LightLoadingSpinner} from '@wallaby-ui/core';
import {documentContainer} from '@wallaby-ui/document';
import React from 'react';

import {NotFoundComponentBox} from '../NotFoundComponentBox';

export type HospitalizationDocumentProps = documentContainer.UseLoadDocumentReturnValue & {
  storageIdPrefix: string;
  documentId: string;
};
export const HospitalizationDocumentV2: React.FC<LightLayoutNodeFCProps & HospitalizationDocumentProps> = (props) => {
  const {storageIdPrefix, isLoading, isError, rawDocumentData, documentId, maximized, setMinimizedMaximized} = props;
  if (isLoading) return <LightLoadingSpinner />;
  if (isError) return <NotFoundComponentBox hideHelmet />;
  return (
    <documentContainer.HospitalizationDocument
      documentData={rawDocumentData}
      documentVersionId={documentId}
      storageIdPrefix={storageIdPrefix}
      maximized={maximized}
      setMinimizedMaximized={setMinimizedMaximized}
    />
  );
};
